import React from 'react';
import styled from 'styled-components';

const HelpDialogTraning4 = (props) => {
    return(
        <React.Fragment>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <b>☆トレーニングガイドは<a href="https://englishcompany-mobile.jp/guide/" target="_blank" rel="noopener noreferrer">こちら</a>☆</b>
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <div><b>2種類のシャドーイングとその効果</b></div>
            <div><b>＜プロソディー・シャドーイング＞</b></div>
            英文の意味内容には注意を向けず、音声だけを意識して行なうシャドーイング。音の聞き取り能力を高めることができます。<br />
            <div><b>＜コンテンツ・シャドーイング＞</b></div>
            音声だけでなく英文の意味内容にも注意を向けて行なうシャドーイング。リスニング・リーディング時の意味を理解する速度も向上させることができます。<br />
            ＝＝＝＝＝＝＝＝＝＝＝＝＝＝＝<br />
            <br />

            <h2>STEP1. 音声を聞く</h2>

            再生ボタンをタップし、音声を一度通して聞きます。<br />
            <br />

            <h2>STEP2. 英文を見ながらシャドーイング</h2>

            再生ボタンをもう一度タップし、音声を聞きながら1、2語遅れで発音していきます。これを2、3回繰り返しましょう。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>音声変化も確認しながら発音や抑揚を再現する</Text></Texts>
            <Texts><Text>✓ </Text><Text>発音が苦手な箇所は、巻き戻し/早送り機能も活用しながら重点的に練習する</Text></Texts>
            <Texts><Text>✓ </Text><Text>どうしても音声についていけない場合は以下の方法を試す</Text></Texts>
            　1.	英文を見ながら音読練習を繰り返す<br />
            　2.	レベルに応じて音声速度を調節する<br />
            <Indent2>＜初級者＞初級レベルの教材を使い、再生速度を0.7倍速などに落として英文を見ながらシャドーイングする。慣れてきたら英文を見る回数を徐々に減らしていく</Indent2>
            <Indent2>＜中級者＞初級レベルの教材を使い、等倍速でシャドーイングする。慣れてきたら中級レベルの教材を低倍速でシャドーイングする</Indent2>
            <Indent2>＜上級者＞速い英語にも対応できる力をつけたい場合は、初級レベルの教材を1.2倍速などに速めてシャドーイングし、中級・上級と徐々にレベルを上げる</Indent2>
            <br />

            <h2>STEP3. 英文を見ずにシャドーイング</h2>

            再生ボタンをタップし、英文を見ずにシャドーイングしていきます。最終的にはコンテンツ・シャドーイングができるようになることが目標です。<br />

            <h3>ポイント</h3>
            <Texts><Text>✓ </Text><Text>プロソディー・シャドーイングが余裕を持ってできるようになってからコンテンツ・シャドーイングを行なう</Text></Texts>
            <Texts><Text>✓ </Text><Text>コンテンツ・シャドーイングを行なう際は、日本語訳を思い浮かべるのではなく、「話し手になったつもりで相手に伝える」「情景を頭の中に描く」というイメージでシャドーイングする</Text></Texts>
            <br />

            <h2>STEP4. シャドーイング音声を録音して送信（※フィードバックプランの方のみ）</h2>

            フィードバックプランの方は、シャドーイング音声を専任トレーナーに添削してもらえます。「録音する」をタップしてシャドーイングを行なうと音声が録音されるので、「送信する」をタップして送信しましょう。<br />
            <br />

            <h2>STEP5. フィードバックの確認（※フィードバックプランの方のみ）</h2>

            専任トレーナーによるフィードバックが1営業日以内に届きます。教材一覧画面から添削内容を確認し、シャドーイングをブラッシュアップしていきましょう。<br />
       </React.Fragment>
    );
}

export { HelpDialogTraning4 };

const Texts = styled.span`
    display: flex;
`;

const Text = styled.span`
    margin: 0;
`;

const Indent2 = styled.span`
    padding-left: 2em;
`;
